import { css } from "@emotion/react"
import cx from "classnames"
import { Icon } from "source/shared/components"

type PostDonateStatusType = "success" | "processing" | "failure"

interface PostDonateStatusProps {
  heading: string
  message: string
  actions: React.ReactNode
  status: PostDonateStatusType
}

function getIconProps(status: PostDonateStatusType) {
  switch (status) {
    case "success":
    case "processing":
      return {
        symbol: "general#check-circle",
        className: "c-emerald",
      }
    case "failure":
      return {
        symbol: "general#exclamation-triangle",
        className: "c-ruby",
      }
  }
}

export function PostDonateStatus({
  heading,
  message,
  actions,
  status,
}: PostDonateStatusProps) {
  const { symbol, className } = getIconProps(status)

  return (
    <section className="d-f fd-c g-3 p-2 px-8@sm mx-8@md">
      <div className="ta-c">
        <Icon
          symbol={symbol}
          className={cx("mb-3", className)}
          aria-hidden
          css={css`
            width: 3rem;
            height: 3rem;
          `}
        />
        <h1 className="mb-2">{heading}</h1>
        <p className="mb-0">{message}</p>
      </div>
      <footer className="d-f fd-c mx-a g-1">{actions}</footer>
    </section>
  )
}
